import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetAPICommand} from '@drl/core/api/commands';
import {environment} from '@drl/env/environment';

import {ContentModel} from '@drl/shared/components/cms-list/models';

export class GetGalleryByIdCommand extends GetAPICommand<ContentModel> {
  constructor(
    apiService: ApiService,
    adapter: IAdapter<ContentModel>,
    id: string,
  ) {
    super(apiService, adapter, `${environment.cmsApiUrl}/gallery/${id}`);
  }
}
